import { SMSNumberService } from '@weave/schema-gen-ts/dist/schemas/sms/number/v1/number_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaSMSNumberV1Service = bindHTTP(SMSNumberService);
export const serviceName = 'number-v1' as const;
